import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('strapSearch', ['watchReference', 'watchCompleteReference']),

    title() {
      if (!this.watchReference) {
        return this.$t('StrapSearch.titleAllStraps');
      }

      return this.$t('StrapSearch.titleForReference', {
        ref: this.watchCompleteReference ?? this.watchReference,
      });
    },
  },
};
